module.exports = __webpack_public_path__ + "img/oldman.cd6c1f95.png";